/**
 * 云服务类别 产品图表页 筛选/列表层
 *
 * @format
 */

import React, { useState, useEffect, useContext, useMemo } from 'react'
import {
  _$,
  Form,
  FormItem,
  Select,
  Option,
  Button,
  Collapse,
  CollapseItem
} from '@king-design/react'
import NoDataComponent from 'src/components/NoData'
import MonitorChartCollapse from './MonitorChartCollapse'
import QuickRangeDate from 'src/components/QuickRangeDate'
import DiabolChartDetails from 'src/containers/MonitorCloud/MonitorCloudChart/DiabolChartDetails'
import { CountContext } from 'src/pages/MonitorCloud/MonitorCloudChart'
import styled from 'styled-components'
import { request } from 'src/utils'
import API from 'src/api/ApiCloud'
import { ChildTypeNameMap } from 'src/utils/menu'
import { MointorItemProps } from '../constants'
import useGlobalData from '../../../hooks/useGlobalData'
import dayjs from 'dayjs'
import { stringNumberSort } from 'src/utils/common'
import { useAsyncFn } from 'react-use'
import { childTypeMap } from 'src/pages/MonitorCloud/constants'

const sub_option_childtypes = [131, 139, 140, 141, 142, 151, 152]
export const ebs_childtypes: any[] = [151, 152]
const shard_childtypes: number[] = [53, 168, 178]
const MonitorChartList: React.FC<any> = ({ className, openExport }) => {
  const {
    curProduct,
    nameSpace,
    regionName,
    topType,
    instanceId,
    instanceName,
    childTypes,
    childTypeValue,
    subInstanceList,
    currentInstance,
    shardList,
    shardValue,
    setChartContext
  } = useContext(CountContext)
  const productMenu = useGlobalData('productMenu')
  const [quickDate, setQucikDate] = useState<string>('近0.5小时')
  const [rangeDate, setRangeDate] = useState<[number, number]>([
    dayjs()
      .subtract(30 * 60, 's')
      .valueOf(),
    dayjs().valueOf()
  ]) // 日期范围
  const [mointorClassData, setMointorClassData] = useState<MointorItemProps[]>([]) // 折叠列表List
  const [mointorClassValue, setMointorClassValue] = useState<any[]>([]) // 当前折叠列表展开的值
  const [detailsVisible, setDetailsVisible] = useState<boolean>(false) // 监控详情弹窗 visible
  const [detailsData, setDetailsData] = useState({}) // 监控详情弹窗 data
  // const [ebsSearch, setEbsSearch] = useState<string>('') // ebs搜索云盘seasrch
  // 每当折叠列表list改变时，默认展开第一个
  useEffect(() => {
    if (mointorClassData.length) {
      setMointorClassValue([mointorClassData[0]?.appId + ''])
    } else {
      setMointorClassValue([])
    }
  }, [mointorClassData])

  // 监控类型change
  const mointorTypeChange = value => {
    const current = childTypes.find(item => item.childType === value)
    setChartContext({
      subInstanceList: [],
      setCurrentInstance: { instanceId: '', instanceName: '' },
      shardList: undefined,
      shardValue: { instanceId: '', instanceName: '' }
    })
    !!current &&
      setChartContext({
        childTypeValue: {
          childType: current.childType,
          childName: current.childName
        }
      })
    if (topType === value) {
      setChartContext({
        subInstanceList: [{ instanceId, instanceName }],
        currentInstance: { instanceId, instanceName }
      })
    } else {
      if (value === 168) {
        value = 167
      } else if (value === 53) {
        value = 52
      }
      if (curProduct?.productType === 142 && ebs_childtypes.includes(value)) {
        getEBSVolumes(value)
      } else {
        getHostExtProperty(value)
      }
    }
  }

  // 142-EBS专属块集群 单独请求二级资源
  // eslint-disable-next-line no-unused-vars
  const [, getEBSVolumes] = useAsyncFn(
    async (childType, search?) => {
      const volumeCategory = {
        151: 'system',
        152: 'data'
      }
      const result = await request(API.getEBSVolumes, {
        method: 'POST',
        data: {
          clusterId: instanceId,
          search,
          volumeCategory: volumeCategory[childType],
          pageNum: 1,
          pageSize: 999
        }
      })
      const resultMap = result?.data?.result?.map(item => ({
        instanceId: item.volumeId,
        instanceName: item.volumeName
      }))
      const firstData = resultMap?.[0] || {}
      setChartContext({
        subInstanceList: resultMap || [],
        currentInstance: {
          instanceId: firstData?.instanceId || '',
          instanceName: firstData?.instanceName || ''
        }
      })
    },
    [instanceId]
  )
  // 获取子实例/节点
  const getHostExtProperty = async (childType, parentInstanceId: string = undefined) => {
    const shardChildType = childTypeMap[childType]
    const {
      data: { resourceList }
    } = await request(API.getChildInstance, {
      method: 'POST',
      data: {
        ProductType: curProduct?.productType,
        ChildType: shardChildType ? shardChildType[0].childType : childType,
        ParentInstanceIds: parentInstanceId ? [parentInstanceId] : [instanceId]
      }
    })
    if (resourceList) {
      const { instanceId, instanceName } = resourceList[0] || {}
      if (shard_childtypes.includes(childType)) {
        // 请求第三级实例List【53、178】
        setChartContext({
          shardList: resourceList || [],
          shardValue: { instanceId, instanceName }
        })
      } else {
        setChartContext({
          subInstanceList: resourceList || [],
          currentInstance: { instanceId, instanceName }
        })
      }
    } else {
      if (shard_childtypes.includes(childType)) {
        setChartContext({
          shardList: [],
          shardValue: { instanceId: '', instanceName: '' }
        })
      } else {
        setChartContext({
          subInstanceList: [],
          currentInstance: { instanceId: '', instanceName: '' },
          shardList: undefined,
          shardValue: { instanceId: '', instanceName: '' }
        })
      }
    }
  }

  // 单一级别：实例切换
  useEffect(() => {
    if (instanceId && !topType && productMenu?.length) {
      getDashboardItem(curProduct?.productType)
    }
  }, [instanceId, productMenu])

  // 特殊产品线（2级）：实例切换
  useEffect(() => {
    const { instanceId } = currentInstance || {}
    if (instanceId && productMenu?.length) {
      const childType = childTypeValue?.childType
      if (!shard_childtypes.includes(childType) && !shardList?.length) {
        setMointorClassData([])
        if (topType) {
          const childType = childTypeValue.childType
          getDashboardItem(childType, instanceId)
        } else {
          getDashboardItem(curProduct?.productType)
        }
      } else {
        getHostExtProperty(childType, instanceId)
      }
    } else {
      setMointorClassData([])
    }
  }, [currentInstance?.instanceId, productMenu])

  // shardNode：实例切换
  useEffect(() => {
    setMointorClassData([])
    const childType = childTypeValue?.childType
    if (
      shard_childtypes.includes(childType) &&
      shardList?.length &&
      shardValue &&
      productMenu?.length
    ) {
      shardValue.instanceId &&
        getDashboardItem(childType === 178 ? 179 : childType, shardValue.instanceId)
    }
  }, [shardValue, productMenu])

  // 获取监控项
  const getDashboardItem = async (
    productType,
    instance = instanceId // 默认实例ID
  ) => {
    if (productType !== undefined) {
      // const product = findProduct(productType)
      const { data } = await request(API.getDescribeScreen, {
        data: {
          Name: ChildTypeNameMap[productType],
          // Name: product?.screenName,
          InstanceId: instance,
          ProductType: productType
        }
      })
      if (data?.data?.applications?.length) {
        data?.data?.applications.sort(function (metric1, metric2) {
          return metric2.graphs?.length - metric1.graphs?.length
        })
        setMointorClassData(data?.data?.applications)
      }
    }
  }

  // 实例change
  const instanceChange = value => {
    const find = subInstanceList.find(({ instanceId }) => value === instanceId)
    setChartContext({
      currentInstance: {
        instanceId: find?.instanceId,
        instanceName: find?.instanceName
      }
    })
  }

  // shard change
  const shardChange = value => {
    const find = shardList.find(({ instanceId }) => value === instanceId)
    setChartContext({
      shardValue: {
        instanceId: find?.instanceId,
        instanceName: find?.instanceName
      }
    })
  }

  // 获取所有维度
  const appTags = useMemo(() => {
    if (mointorClassData?.length) {
      const result = {}
      mointorClassData.forEach(({ appId, graphs }) => {
        graphs?.forEach(({ lines }) => {
          lines?.forEach(({ tags, metricType }) => {
            if (metricType === 1 && tags?.p1 && !result?.[appId]?.includes(tags?.p1)) {
              if (result?.[appId]) {
                result[appId].push(tags?.p1)
              } else {
                result[appId] = [tags?.p1]
              }
            }
          })
        })
      })
      return result
    } else {
      return {}
    }
  }, [mointorClassData])
  // 打开监控详情弹窗
  const openDetails = (data, tags) => {
    setDetailsVisible(true)
    setDetailsData({
      ...data,
      tags
    })
  }
  // 关闭监控详情弹窗
  const closeDetails = () => {
    setDetailsVisible(false)
    setDetailsData({})
  }

  // 切换卡片
  const collapseChange = value => {
    if (value) {
      setTimeout(() => {
        const anchorElement = document.getElementById(value[0])
        if (anchorElement) {
          const top = anchorElement.offsetTop - 58
          window.scrollTo({ top })
        }
      }, 300)
      setMointorClassValue(value)
    }
  }

  // 导出
  const handleExport = () => {
    openExport(mointorClassData, rangeDate)
  }

  // 渲染资源展示名称
  const renderInstanceOptionText = (childType, name, id, ip) => {
    /* 容器实例展示实例名称 */
    const showNameType = [71, 96, 107, 160]
    const mongodbs = [51, 53, 57, 167, 168, 170]
    if (showNameType.includes(childType)) {
      return name
    } else if (mongodbs.includes(childType) && ip) {
      return `${ip}--${id}`
    } else if (sub_option_childtypes.includes(childType)) {
      return (
        <div className="sub-option-item">
          <p>{name}</p>
          <p style={{ color: '#ccc' }}>{id}</p>
        </div>
      )
    } else {
      return id
    }
  }

  return (
    <div className={className}>
      <div className="chart-filter">
        <Form>
          <FormItem label={_$('查找卡片')}>
            <Select width={350} multiple value={mointorClassValue} onChangeValue={collapseChange}>
              {mointorClassData?.length &&
                mointorClassData.map(({ name, appId }) => (
                  <Option key={appId} value={appId + ''}>
                    {name}
                  </Option>
                ))}
            </Select>
          </FormItem>
        </Form>
        <div className="right_filter ksc-space">
          <QuickRangeDate
            format="YYYY-MM-DD HH:mm"
            optionalDateRange={90}
            dateDiff={30}
            defautlValue={quickDate || rangeDate}
            quickRange={[
              '近5分钟',
              '近0.5小时',
              '近1小时',
              '近3小时',
              '近1天',
              '近3天',
              '近1周',
              '近30天'
            ]}
            clearable={false}
            changeValue={(date, quick) => {
              setQucikDate(quick)
              setRangeDate(date)
            }}
          />
          <Button onClick={handleExport}>{_$('导出')}</Button>
          {/* <Icon onClick={handleExport} className="ion-android-download" /> */}
        </div>
      </div>
      {!!topType && childTypes && !!childTypes.length && (
        <div className="select-child">
          <Form>
            <FormItem label={_$('监控类型')}>
              <Select
                width={200}
                value={childTypeValue.childType}
                onChangeValue={mointorTypeChange}
              >
                {childTypes?.length &&
                  childTypes.map(({ childType, childName }) => (
                    <Option key={childType} value={childType}>
                      {_$(childName)}
                    </Option>
                  ))}
              </Select>
            </FormItem>
            <FormItem label={_$(childTypeValue.childName)} className="child-name-select">
              <Select
                width={335}
                value={currentInstance.instanceId}
                onChangeValue={instanceChange}
                filterable
                container=".child-name-select"
              >
                {subInstanceList?.length
                  ? subInstanceList.map(({ instanceId, instanceName, instanceIP }) => (
                      <Option
                        key={instanceId}
                        label={
                          sub_option_childtypes?.includes(childTypeValue?.childType)
                            ? instanceName
                            : undefined
                        }
                        value={instanceId}
                      >
                        {/* 容器实例展示实例名称 */}
                        {renderInstanceOptionText(
                          childTypeValue?.childType,
                          instanceName,
                          instanceId,
                          instanceIP
                        )}
                      </Option>
                    ))
                  : null}
              </Select>
            </FormItem>
            {shardList ? (
              <FormItem label={_$('分片节点')}>
                <Select width={335} value={shardValue.instanceId} onChangeValue={shardChange}>
                  {shardList.map(({ instanceId, instanceIP }) => (
                    <Option key={instanceId} value={instanceId}>
                      {`${instanceIP}--${instanceId}`}
                    </Option>
                  ))}
                </Select>
              </FormItem>
            ) : null}
          </Form>
        </div>
      )}

      <Collapse
        value={mointorClassValue}
        onChangeValue={value => {
          setMointorClassValue(value)
        }}
      >
        {mointorClassData.length > 0 ? (
          mointorClassData.map(({ name, appId, graphs }) => {
            return (
              <CollapseItem
                value={appId + ''}
                key={`collapseItem-${appId}`}
                slotTitle={
                  <div className="collapse-item-title">
                    <b>{_$(name)}</b>
                    <span>{`共${graphs.length}个视图`}</span>
                  </div>
                }
              >
                <MonitorChartCollapse
                  productType={childTypeValue?.childType || curProduct?.productType}
                  appId={appId + ''}
                  graphs={graphs}
                  tagOpts={appTags?.[appId]?.sort(stringNumberSort) || []}
                  rangeDate={rangeDate}
                  instanceId={shardValue?.instanceId || currentInstance?.instanceId || instanceId}
                  mointorClassValue={mointorClassValue}
                  openDetails={openDetails}
                />
              </CollapseItem>
            )
          })
        ) : (
          <NoDataComponent />
        )}
      </Collapse>

      {/* 图表详情 */}
      <DiabolChartDetails
        visible={detailsVisible}
        region={regionName}
        nameSpace={nameSpace}
        closeDetails={closeDetails}
        productType={
          childTypeValue?.childType === 178
            ? 179
            : childTypeValue?.childType || curProduct?.productType
        }
        graph={detailsData}
        rangeDate={rangeDate}
        quickDate={quickDate}
        mointorClassData={mointorClassData}
      />
    </div>
  )
}

export default React.memo(styled(MonitorChartList)`
  min-height: calc(100vh - 100px);
  padding-bottom: 20px;
  .chart-filter {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 16px 16px 0 0;
    background: #fff;
    .k-form {
      padding-bottom: 16px;
    }
    .right_filter {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0 16px 8px;
    }
  }
  .select-child {
    padding: 16px 16px 16px 0;
    margin-top: 16px;
    background: #fff;
    .k-form {
      display: flex;
      .k-form-item {
        margin: 0 10px 0 0;
        .k-form-label {
          min-width: 5rem;
        }
      }
      .child-name-select {
        .k-form-label {
          width: auto;
          white-space: nowrap;
        }
        .k-dropdown-menu {
          .k-select-option {
            height: auto;
            .sub-option-item {
              p {
                margin: 0;
                line-height: 22px;
              }
            }
          }
        }
      }
    }
  }
  .k-collapse {
    padding: 0;
    .k-collapse-item {
      margin-top: 16px;
      border-bottom: none;
      & > .k-collapse-title {
        height: 48px;
        line-height: 48px;
        background: #fff;
        padding: 0 24px;
        display: flex;
        justify-content: space-between;
        .collapse-item-title {
          b {
            font-size: 14px;
            margin-right: 8px;
          }
          span {
            color: #999;
            font-size: 12px;
            font-weight: 400;
          }
        }
      }
      & > .k-content > .k-wrapper {
        padding: 10px 0;
      }
    }
  }
`)
